/* eslint react/no-multi-comp: 0, react/prop-types: 0 */

import React from 'react'
import { Modal, ModalBody } from 'reactstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimes } from '@fortawesome/free-solid-svg-icons'
import './modalInfo.scss'

const ModalInfo = (props: any) => {
  const { isShowModal, onCloseModal, compContent, title, className } = props

  const toggle = () => onCloseModal()

  return (
    <div>
      <Modal isOpen={isShowModal} toggle={toggle} className={className}>
        <div className='modal-header'>
          <h5 className='modal-title'>{title}</h5>
          <button
            type='button'
            onClick={toggle}
            className='btn close'
            aria-label='Close'
          >
            <FontAwesomeIcon icon={faTimes} />
          </button>
        </div>
        <ModalBody>{compContent}</ModalBody>
      </Modal>
    </div>
  )
}

export default ModalInfo
